<template>
  <core-popup
    show
  >
    <template #body>
      <div
        :class="$style.confirm_popup"
        :style="{ maxWidth: config.width ? config.width + 'px' : 420 + 'px' }"
      >
        <div
          v-if="!config.showThanks"
          :class="$style.body"
        >
          <div
            v-if="config.title"
            :class="$style.head"
          >
            <div
              v-if="config.title"
              :class="$style.head__left"
            >
              {{ locale(`message_header_title_${config.title}`) }}
            </div>
            <div
              :class="$style.head__right"
            >
              <svg-sprite
                :name="'close-1'"
                :type="'bold'"
                :size="24"
                :color="'#999999'"
                :class="$style.close_icon"
                @onClick="closeClick"
              />
            </div>
          </div>

          <div
            v-if="config.message"
            :class="$style.confirm_message"
            v-html="config.message"
          />
          <div
            v-else
            :class="$style.confirm_message"
            v-html="locale(`message_view_text_${config.title}`)"
          />

          <div :class="$style.area">
            <vgp-text-area
              :placeholder="locale(`message_view_placeholder_${config.title}`)"
              :styles="isEmpty ? 'border-color: #E53935; height: 180px; resize: none' : 'height: 180px; resize: none'"
              :handle-input="setValue"
              :value="message"
              :class="$style.textarea"
              :error-message="isEmpty ? `${locale(`message_view_text_error`)}` : null"
            />
          </div>

          <div :class="$style.buttons">
            <vgp-button
              type="primary"
              :label="locale(`message_view_button_${config.title}`)"
              :small="true"
              @onClick="confirmClick"
            />
          </div>
        </div>
        <div v-else>
          <div
            v-if="config.title"
            :class="$style.head"
          >
            <div
              v-if="config.title"
              :class="$style.head__left"
            >
              {{ locale(`thanks_description_title_${config.title}`) }}
            </div>
          </div>
          <div
            :class="$style.thanks_box"
          >
            <svg-image
              name="feedback-thanks"
              :class="$style.thanks_image"
            />
            <div
              :class="$style.thanks_description"
              v-html="locale(`nps_thank_popup_title_${config.title}`)"
            />
          </div>

          <div :class="$style.buttons">
            <vgp-button
              type="primary"
              :label="locale(`but_ok_${config.title}`)"
              :small="true"
              @onClick="closeClick"
            />
          </div>
        </div>
      </div>
    </template>
  </core-popup>
</template>

<script>
import axios from 'axios';
import corePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import vgpButton from '$$vueCmp/globalButton/vgpButton.vue';
import vgpTextArea from '$$vueCmp/vInput/vTextArea.vue';
import plansModel from '../../../../../models/plans';
import svgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';

export default {
  components: {
    corePopup,
    vgpButton,
    vgpTextArea,
    svgImage,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      locale: __,
      message: null,
      isEmpty: false,
    };
  },

  mounted() {
    userExtAnalytics.log('pricing_contact_us_opened', this.config?.data?.name || '');
  },
  methods: {
    setValue(val) {
      this.message = val;
      this.isEmpty = !(val.length > 0);
    },
    closeClick() {
      this.$store.dispatch('globalPopup/close');
    },
    confirmClick() {
      if (this.message && this.message.length > 0) {
        axios.post('/api/feedback/', {
          email: user.email,
          user_name: user.username,
          last_name: user.firstName,
          first_name: user.lastName,
          company: user.settings.user_company,
          company_size: user.settings.user_team,
          industry: user.settings.user_industry,
          phone: user.settings.user_phone,
          user_payment_plan: plansModel.getSubscriptionName(),
          user_payment_provider: plansModel.getSubscriptionProvider(),
          lang: 'en', // user.locale,
          user_id: user.id,
          message: this.message,
          type: this.config.title || this.config.type,
          send_followup_email: false,
        }).then(data => {
          userExtAnalytics.log('pricing_contact_us_sent', this.config?.data?.name || '');
          this.$store.dispatch('globalPopup/close');
          this.$store.dispatch('globalPopup/show', {
            showThanks: true,
            type: 'contactUs',
            title: this.config.title || this.config.type,
            width: 565,
          });
        });
      } else {
        this.isEmpty = true;
      }
    },
  },
};
</script>

<style module src="./contactUsPopup.less" lang="less"></style>
